import React from "react";
import { Container, Title } from "./styled/PrimeLayout.styled";
import DashLine from "./elements/DashLine";
import PropTypes from "prop-types";

export default function PrimeLayout({ title, children }) {
  return (
    <Container>
      <DashLine />
      <Title>{title || "Title"}</Title>
      {children}
    </Container>
  );
}

PrimeLayout.propTypes = {
  title: PropTypes.string,
};

PrimeLayout.defaultProps = {
  title: "Title",
};
